import React from 'react';
import * as yup from 'yup';
import FormSection from '../../../../common/hookFormComponents/FormSection';

const fields = [
  {
    colSpan: 1,
    name: 'local',
    type: 'text',
    label: 'Local (%)',
  },
  {
    colSpan: 1,
    name: 'exportable',
    type: 'text',
    label: 'Exportable %',
  },
];

export const marketingFinishedProductFieldsValidation = {
  [fields[0].name]: yup.string().label(fields[0].lable),
  [fields[1].name]: yup.string().label(fields[1].lable),
};

const MarketingFinisheProductSection = (props) => {
  return (
    <FormSection
      sectionName="Marketing of Finished Product"
      sectionColumn={2}
      formFields={fields}
      {...props}
    />
  );
};

export default MarketingFinisheProductSection;
